import { css } from '@emotion/react';

export interface ShapeProps {
  color: string;
  size: {
    width: number;
    height: number;
  };
}

export const Circle = ({ color, size }: ShapeProps) => (
  <div
    css={css`
      width: ${size.width}px;
      height: ${size.height}px;
      background-color: ${color};
      border-radius: 50%;
    `}
  />
);

export const Star = ({ color, size }: ShapeProps) => {
  const { width, height } = size;
  const cx = width / 2;
  const cy = height / 2;
  const outerRadius = Math.min(width, height) / 2;
  const innerRadius = outerRadius * 0.4;

  const points: string[] = [];
  for (let i = 0; i < 5; i += 1) {
    // Outer point
    const outerAngle = (i * 72 - 90) * (Math.PI / 180);
    points.push(`${cx + outerRadius * Math.cos(outerAngle)},${cy + outerRadius * Math.sin(outerAngle)}`);
    // Inner point
    const innerAngle = ((i * 72) + 36 - 90) * (Math.PI / 180);
    points.push(`${cx + innerRadius * Math.cos(innerAngle)},${cy + innerRadius * Math.sin(innerAngle)}`);
  }

  return (
    <svg width={width} height={height} aria-hidden='true' focusable='false'>
      <polygon
        points={points.join(' ')}
        fill={color}
      />
    </svg>
  );
};

export const Triangle = ({ color, size }: ShapeProps) => {
  const { width, height } = size;
  const points = `${width / 2},0 ${width},${height} 0,${height}`;

  return (
    <svg width={width} height={height} aria-hidden='true' focusable='false'>
      <polygon
        points={points}
        fill={color}
      />
    </svg>
  );
};
